define('drops/taskProgress/taskProgress',[
    'jquery',
    'lq/drop',
    'lq/style',
    'underscore'
], function ($, Drop, Style, _) {
    'use strict';

    var TaskProgress = function(options) {
        Drop.call(this, $('<div/>'), options);
        var self = this;

        self.$element
            .addClass('boxToBorderSize')
            .addClass('taskprogress')
            .addClass('taskprogress-' + (self.data.styleId ? self.data.styleId.split('/')[1] : 'default'));

        self.$canvas = $('<canvas />')
            .attr('height', self.data.size.y + 'px')
            .attr('width', self.data.size.x + 'px')
            .appendTo(self.$element);
        // FIXME: crashes in IE8, no canvas
        self.ctx = self.$canvas
            .get(0)
            .getContext('2d');
    };

    Drop.extend(TaskProgress, Drop);

    TaskProgress.typeName = 'TaskProgress';

    TaskProgress.prototype.preRender = function () {
        var self = this;
        this.piping.datasources.registerDatasourceListener(
            this.data.dataSource,
            function (data) {
                self.update(data);
            });

        this.applyPosition();
    };

    TaskProgress.prototype.postRender = function () {
        this.buildLinks();
        this.drawAllLinks();

        this.borderPadding = parseInt(this.$element.css('border-width'), 10);
        // this is a hack for passing the line width to the drop through our stylesheet
        this.lineWidth = parseInt(this.$canvas.css('line-height'), 10);
    };

    TaskProgress.prototype.render = function ($element) {
    	return this.createAndRenderDrops($element);
    };

    TaskProgress.prototype.buildLinks = function () {
        var self = this;

        self.links = _.map(self.data.links, function (link) {
            return {
                drop1: _.find(self.pool, function (drop) {
                    return drop.data.id === link.morph1;
                }),
                drop2: _.find(self.pool, function (drop) {
                    return drop.data.id === link.morph2;
                })
            };
        });
    };

    TaskProgress.prototype.clearCanvas = function () {
        this.ctx.clearRect(0, 0, this.$canvas.width(), this.$canvas.height());
    };

    TaskProgress.prototype.drawAllLinks = function () {
        var self = this;

        self.clearCanvas();
        
        for (var i = 0; i < this.links.length; i++) {
            var link = this.links[i];

            if (this.checkLinkCanBuild(link))
                this.drawOneLink(link.drop1, link.drop2);
            else {
                this.links.splice(i, 1);
            }
        }
    };

    TaskProgress.prototype.checkLinkCanBuild = function (link) {
        return $.inArray(link.drop1, this.pool) != -1 && $.inArray(link.drop2, this.pool) != -1;
    };

    TaskProgress.prototype.drawOneLink = function (drop1, drop2) {
        var point1 = {
            x: drop1.data.position.x + this.borderPadding + (drop1.data.size.x / 2),
            y: drop1.data.position.y + this.borderPadding + (drop1.data.size.y / 2)
        };
        var point2 = {
            x: drop2.data.position.x + this.borderPadding + (drop2.data.size.x / 2),
            y: drop2.data.position.y + this.borderPadding + (drop2.data.size.y / 2)
        };

        this.ctx.beginPath();

        if (drop2.completionPercentage < 50) {
            this.ctx.strokeStyle = drop2.$element
                .find('.incomplete')
                .css('background-color');
        } else {
            this.ctx.strokeStyle = drop2.$element
                .css('background-color');
        }

        this.ctx.moveTo(point1.x, point1.y);
        this.ctx.lineTo(point2.x, point2.y);
        this.ctx.lineWidth = this.lineWidth;
        this.ctx.closePath();
        this.ctx.stroke();
    };

    TaskProgress.prototype.update = function (data) {
        _.forEach(this.pool, function (task) {
            var completionStatus = data.Results[0][task.data.dataSourceOutput];
            task.setCompletionPercentage(completionStatus);
        });

        this.drawAllLinks();
    };

    return TaskProgress;
});
